import { IFormatter } from '../FormatterTypes';
import { TEDValidateDefault } from '../Validators/TEDValidateDefault';
import { TEDParseDateYear } from '../Parsers/TEDParseDateYear';
import { TEDDisplayDateYear } from '../Displayers/TEDDisplayDateYear';

class TEDFormatDateYear implements IFormatter {
  displayer = TEDDisplayDateYear.getInstance();
  parser = TEDParseDateYear.getInstance();
  validator = TEDValidateDefault.getInstance();
}

export { TEDFormatDateYear };
